/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const nationalities = [
  { label: "Deutschland" },
  { label: "Türkei" },
  { label: "Polen" },
  { label: "Italien" },
  { label: "Syrien" },
  { label: "Österreich" },
  { label: "Schweiz" },
  { label: "Afghanistan" },
  { label: "Ägypten" },
  { label: "Albanien" },
  { label: "Algerien" },
  { label: "Andorra" },
  { label: "Angola" },
  { label: "Antigua und Barbuda" },
  { label: "Äquatorialguinea" },
  { label: "Argentinien" },
  { label: "Armenien" },
  { label: "Aserbaidschan" },
  { label: "Äthiopien" },
  { label: "Australien" },
  { label: "Bahamas" },
  { label: "Bahrain" },
  { label: "Bangladesch" },
  { label: "Barbados" },
  { label: "Belgien" },
  { label: "Belize" },
  { label: "Benin" },
  { label: "Bhutan" },
  { label: "Bolivien" },
  { label: "Bosnien und Herzegowina" },
  { label: "Botswana" },
  { label: "Brasilien" },
  { label: "Brunei" },
  { label: "Bulgarien" },
  { label: "Burkina Faso" },
  { label: "Burundi" },
  { label: "Chile" },
  { label: "China" },
  { label: "Cookinseln" },
  { label: "Costa Rica" },
  { label: "Côte d'Ivoire" },
  { label: "Dänemark" },
  { label: "Dominica" },
  { label: "Dominikanische Republik" },
  { label: "Dschibuti" },
  { label: "Ecuador" },
  { label: "El Salvador" },
  { label: "Eritrea" },
  { label: "Estland" },
  { label: "Fidschi" },
  { label: "Finnland" },
  { label: "Frankreich" },
  { label: "Gabun" },
  { label: "Gambia" },
  { label: "Georgien" },
  { label: "Ghana" },
  { label: "Grenada" },
  { label: "Griechenland" },
  { label: "Großbritannien" },
  { label: "Guatemala" },
  { label: "Guinea" },
  { label: "Guinea-Bissau" },
  { label: "Guyana" },
  { label: "Haiti" },
  { label: "Honduras" },
  { label: "Indien" },
  { label: "Indonesien" },
  { label: "Irak" },
  { label: "Iran" },
  { label: "Irland" },
  { label: "Island" },
  { label: "Israel" },
  { label: "Jamaika" },
  { label: "Japan" },
  { label: "Jemen" },
  { label: "Jordanien" },
  { label: "Kambodscha" },
  { label: "Kamerun" },
  { label: "Kanada" },
  { label: "Kap Verde" },
  { label: "Kasachstan" },
  { label: "Katar" },
  { label: "Kenia" },
  { label: "Kirgisistan" },
  { label: "Kiribati" },
  { label: "Kolumbien" },
  { label: "Komoren" },
  { label: "Kongo" },
  { label: "Kosovo" },
  { label: "Kroatien" },
  { label: "Kuba" },
  { label: "Kuwait" },
  { label: "Laos" },
  { label: "Lesotho" },
  { label: "Lettland" },
  { label: "Libanon" },
  { label: "Liberia" },
  { label: "Libyen" },
  { label: "Liechtenstein" },
  { label: "Litauen" },
  { label: "Luxemburg" },
  { label: "Madagaskar" },
  { label: "Malawi" },
  { label: "Malaysia" },
  { label: "Malediven" },
  { label: "Mali" },
  { label: "Malta" },
  { label: "Marokko" },
  { label: "Marshallinseln" },
  { label: "Mauretanien" },
  { label: "Mauritius" },
  { label: "Mazedonien" },
  { label: "Mexiko" },
  { label: "Mikronesien" },
  { label: "Moldawien" },
  { label: "Monaco" },
  { label: "Mongolei" },
  { label: "Montenegro" },
  { label: "Mosambik" },
  { label: "Myanmar" },
  { label: "Namibia" },
  { label: "Nauru" },
  { label: "Nepal" },
  { label: "Neuseeland" },
  { label: "Nicaragua" },
  { label: "Niederlande" },
  { label: "Niger" },
  { label: "Nigeria" },
  { label: "Niue" },
  { label: "Nordkorea" },
  { label: "Norwegen" },
  { label: "Oman" },
  { label: "Pakistan" },
  { label: "Palau" },
  { label: "Panama" },
  { label: "Papua-Neuguinea" },
  { label: "Paraguay" },
  { label: "Peru" },
  { label: "Philippinen" },
  { label: "Portugal" },
  { label: "Ruanda" },
  { label: "Rumänien" },
  { label: "Russland" },
  { label: "Salomonen" },
  { label: "Sambia" },
  { label: "Samoa" },
  { label: "San Marino" },
  { label: "São Tomé und Príncipe" },
  { label: "Saudi-Arabien" },
  { label: "Schweden" },
  { label: "Senegal" },
  { label: "Serbien" },
  { label: "Seychellen" },
  { label: "Sierra Leone" },
  { label: "Simbabwe" },
  { label: "Singapur" },
  { label: "Slowakei" },
  { label: "Slowenien" },
  { label: "Somalia" },
  { label: "Spanien" },
  { label: "Sri Lanka" },
  { label: "St. Kitts und Nevis" },
  { label: "St. Lucia" },
  { label: "St. Vincent/Grenadinen" },
  { label: "Südafrika" },
  { label: "Sudan" },
  { label: "Südkorea" },
  { label: "Suriname" },
  { label: "Swasiland" },
  { label: "Tadschikistan" },
  { label: "Taiwan" },
  { label: "Tansania" },
  { label: "Thailand" },
  { label: "Timor-Leste" },
  { label: "Togo" },
  { label: "Tonga" },
  { label: "Trinidad und Tobago" },
  { label: "Tschad" },
  { label: "Tschechien" },
  { label: "Tunesien" },
  { label: "Turkmenistan" },
  { label: "Tuvalu" },
  { label: "Uganda" },
  { label: "Ukraine" },
  { label: "Ungarn" },
  { label: "Uruguay" },
  { label: "Usbekistan" },
  { label: "Vanuatu" },
  { label: "Vatikanstadt" },
  { label: "Venezuela" },
  { label: "Vereinigte Arabische Emirate" },
  { label: "Vereinigte Staaten von Amerika" },
  { label: "Vietnam" },
  { label: "Weißrussland" },
  { label: "Zentralafrikanische Republik" },
  { label: "Zypern" },
];

export default nationalities;
